import Filters from './filters/Filters.vue';
import Sidebar from './sidebar.vue';
import BoxesList from './filters/select/BoxesList.vue';
import Vue from 'vue';
import App from "../app";
import axios from "axios";
import FiltersSelected from './filters/FiltersSelected.vue';
import FiltersMainCategories from './filters/FiltersMainCategories.vue';
import FiltersSubCategories from './filters/FiltersSubCategories.vue';

export default class ProductFilters {
    private elem: HTMLElement;

    static factory(): void {
        document.querySelectorAll('[data-products]').forEach((elem: HTMLElement) => {
            new ProductFilters(elem);
        });
    }

    constructor(elem: HTMLElement) {
        this.elem = elem;

        this.initFilters();
    }

    private initFilters() {
        new Vue({
            el: this.elem,
            data: {
                filters: {
                    fields: App.getData('filters.fields'),
                    model: App.getData('filters.model'),
                    selected: App.getData('filters.selected'),
                    maincategories: App.getData('filters.main_categories'),
                    subcategories: App.getData('filters.sub_categories'),
                }
            },
            components: {
                Filters,
                FiltersSelected,
                FiltersMainCategories,
                FiltersSubCategories,
                BoxesList,
                Sidebar
            },
            mounted: function() {
                window.history.replaceState(this.filters.model, null, window.location.href);

                window.addEventListener('popstate', (event) => {
                    this.search(event.state);
                });
            },
            watch: {
                'filters.model': {
                    deep: true,
                    handler: function() {
                        this.search(this.filters.model);
                    }
                }
            },
            methods: {
                search(model) {
                    this.closeSidebars();
                    axios.get('', {
                        params: {
                            action: 'filter_search',
                            query: JSON.stringify(model)
                        }
                    }).then((response) => {
                        if (response.data.success === true) {
                            this.filters.selected = response.data.selected;
                            this.filters.maincategories = response.data.main_categories;
                            this.filters.subcategories = response.data.sub_categories;
                            this.filters.fields = response.data.filters.fields;
                            this.$el.querySelector('.hits').innerHTML = response.data.hits;
                            this.$el.querySelector('.products').innerHTML = response.data.products;

                            window.history.pushState(model, null, response.data.url);
                        }
                    });
                },
                closeSidebars() {
                    this.$refs.filtersSidebar.close();
                    this.$refs.sortingSidebar.close();
                }
            },
            computed: {
                fields() {
                    return this.filters.fields.filter((field) => {
                        return field.id !== 'order';
                    })
                },
                fieldOrder() {
                    return this.filters.fields.find((field) => {
                        return field.id === 'order';
                    })
                }
            }
        })
    }
}